<template>
  <svg
    v-if="!props.active"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0617 4C14.8409 4 17.1017 6.28771 17.1017 9.1C17.1017 11.9123 14.8409 14.2 12.0617 14.2C9.28252 14.2 7.02172 11.9123 7.02172 9.1M19.5 20C19.5 18.1786 18 14.5 13.5001 14.2H10.6201C6 14.5 4.5 18.1786 4.5 20"
      stroke="#4D4D4D"
      stroke-width="1.5" />
    <path
      d="M6.96143 9.10063C6.96143 6.32143 9.24914 4.06062 12.0614 4.06062C14.8737 4.06062 17.1614 6.32143 17.1614 9.10063C17.1614 11.8798 14.8737 14.1406 12.0614 14.1406"
      stroke="#4D4D4D"
      stroke-width="1.5" />
    <path
      d="M21 8.00006C21 8.55234 20.5523 9.00006 20 9.00006C19.4477 9.00006 19 8.55234 19 8.00006C19 7.44777 19.4477 7.00006 20 7.00006C20.5523 7.00006 21 7.44777 21 8.00006Z"
      fill="#333333" />
    <path
      d="M5 14.0001C5 14.5523 4.55228 15.0001 4 15.0001C3.44772 15.0001 3 14.5523 3 14.0001C3 13.4478 3.44772 13.0001 4 13.0001C4.55228 13.0001 5 13.4478 5 14.0001Z"
      fill="#333333" />
  </svg>
  <svg
    v-else
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3669_9689)">
      <g filter="url(#filter0_d_3669_9689)">
        <path
          d="M21 8.00006C21 8.55234 20.5523 9.00006 20 9.00006C19.4477 9.00006 19 8.55234 19 8.00006C19 7.44777 19.4477 7.00006 20 7.00006C20.5523 7.00006 21 7.44777 21 8.00006Z"
          fill="white" />
      </g>
      <g filter="url(#filter1_d_3669_9689)">
        <path
          d="M5 14.0001C5 14.5523 4.55228 15.0001 4 15.0001C3.44772 15.0001 3 14.5523 3 14.0001C3 13.4478 3.44772 13.0001 4 13.0001C4.55228 13.0001 5 13.4478 5 14.0001Z"
          fill="white" />
      </g>
      <path
        d="M12.0617 4C14.8409 4 17.1017 6.28771 17.1017 9.1C17.1017 11.9123 14.8409 14.2 12.0617 14.2C9.28252 14.2 7.02172 11.9123 7.02172 9.1M19.5 20C19.5 18.1786 18 14.5 13.5001 14.2H10.6201C6 14.5 4.5 18.1786 4.5 20"
        stroke="url(#paint0_linear_3669_9689)"
        stroke-width="1.5" />
      <path
        d="M16.478 11.6499C15.0884 14.0568 11.9768 14.8708 9.54132 13.4647C7.10581 12.0585 6.25499 8.95678 7.64459 6.54992C9.03419 4.14307 12.1458 3.32901 14.5813 4.73516"
        stroke="url(#paint1_linear_3669_9689)"
        stroke-width="1.5" />
      <circle
        cx="12.0242"
        cy="21.0709"
        r="7.33857"
        transform="rotate(120 12.0242 21.0709)"
        fill="url(#paint2_linear_3669_9689)" />
    </g>
    <defs>
      <filter
        id="filter0_d_3669_9689"
        x="17"
        y="5"
        width="6"
        height="6"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3669_9689" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3669_9689"
          result="shape" />
      </filter>
      <filter
        id="filter1_d_3669_9689"
        x="1"
        y="11"
        width="6"
        height="6"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3669_9689" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3669_9689"
          result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_3669_9689"
        x1="16"
        y1="9"
        x2="13.5"
        y2="11"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FE" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3669_9689"
        x1="15.3437"
        y1="8.61463"
        x2="12.6117"
        y2="9.34668"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FE" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FE" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3669_9689"
        x1="9.6266"
        y1="23.0609"
        x2="6.66322"
        y2="25.9277"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FF" />
      </linearGradient>
      <clipPath id="clip0_3669_9689">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});
</script>
